import { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { Link as RouterLink } from 'react-router-dom';
import { Button, Heading, Paragraph, Tag } from '@digdir/designsystemet-react';
import type { SafetyRepTask } from '../../../api/safetyRepWork';
import { TASK_COLORS, taskLink, taskTexts } from '../safetyRepWorkView';
import layout from '../../HRDashboard/hmsPage.module.css';
import classes from '../SafetyRep.module.css';

/** One task, with a button to where it is done */
export const TaskItem = ({
  task,
  primary,
}: {
  task: SafetyRepTask;
  primary: boolean;
}): ReactElement => {
  const { t, i18n } = useTranslation();
  const texts = taskTexts(task, t, i18n.language);
  return (
    <div className={classes.task}>
      <div className={classes.taskText}>
        <span className={classes.taskMeta}>
          <Tag data-size="sm" data-color={TASK_COLORS[task.kind]}>
            {texts.kind}
          </Tag>
          <span className={`ds-paragraph ${layout.subtle}`} data-size="xs">
            {texts.meta}
          </span>
        </span>
        <Heading level={3} data-size="2xs">
          {texts.title}
        </Heading>
        <Paragraph data-size="sm" className={classes.text}>
          {texts.text}
        </Paragraph>
      </div>
      <Button
        asChild
        variant={primary ? 'primary' : 'secondary'}
        data-size="sm"
      >
        <RouterLink to={taskLink(task)}>{texts.action}</RouterLink>
      </Button>
    </div>
  );
};
